<template>
  <v-dialog
    overlay-color="rgba(0,0,0,0.4)"
    overlay-opacity="0.8"
    v-model="state"
    max-width="520"
    persistent
  >
    <ValidationObserver v-slot="{ handleSubmit }">
      <v-form @submit.prevent="handleSubmit(editLube)" class="px-3">
        <v-card flat ref="form">
          <v-card-title>
            <span class="font-weight-bold blue-grey--text">Edit Lube</span>
            <v-spacer></v-spacer>
            <v-progress-linear
              v-show="progress"
              class="mx-6"
              indeterminate
              color="cyan"
            ></v-progress-linear>
          </v-card-title>
          <v-card-text>
            <v-col>
              <v-row>
                <ValidationProvider
                  tag="div"
                  class="d-flex flex-row flex-grow-1"
                  v-slot="{ errors }"
                  rules="required"
                >
                  <v-text-field
                    outlined
                    autofocus
                    v-model="lube.name"
                    label="Name"
                    :error-messages="errors[0]"
                    hint="Name of the lube"
                  />
                </ValidationProvider>
              </v-row>
              <v-row>
                <ValidationProvider
                  tag="div"
                  class="d-flex flex-row flex-grow-1"
                  v-slot="{ errors }"
                  rules="required|numeric"
                >
                  <v-text-field
                    outlined
                    :error-messages="errors[0]"
                    v-model="lube.pack"
                    label="Product Pack"
                    hint="Add the lubes quantity in packs"
                  />
                </ValidationProvider>
              </v-row>

              <v-row>
                <ValidationProvider
                  tag="div"
                  class="d-flex flex-row flex-grow-1"
                  v-slot="{ errors }"
                  rules="required"
                >
                  <v-text-field
                    :error-messages="errors[0]"
                    outlined
                    v-model="lube.retailCostPerUnit"
                    label="Retail Cost Per Unit"
                    hint="Add retail cost per unit"
                  >
                  </v-text-field>
                </ValidationProvider>
              </v-row>
              <v-row>
                <ValidationProvider
                  tag="div"
                  class="d-flex flex-row flex-grow-1"
                  v-slot="{ errors }"
                  rules="required"
                >
                  <v-text-field
                    outlined
                    :error-messages="errors[0]"
                    v-model="lube.sellingPriceToCustomers"
                    label="Selling Price To Customers"
                    hint="Add selling price to customers"
                  >
                  </v-text-field>
                </ValidationProvider>
              </v-row>
              <!-- <v-row>
                  <ValidationProvider
                    tag="div"
                    class="d-flex flex-row flex-grow-1"
                    v-slot="{ errors }"
                    rules="numeric"
                  >
                    <v-text-field
                      outlined
                      :error-messages="errors[0]"
                      v-model="lube.minimumThreshold"
                      label="Minimum Lubes Threshold"
                      hint="Mimum threshold  for the products"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-row> -->
            </v-col>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn class="mr-2 text-capitalize" text @click="close">
              Cancel
            </v-btn>
            <v-btn
              color="primary"
              :loading="loading"
              type="submit"
              class=" white--text text-capitalize"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { numeric, required, double } from "vee-validate/dist/rules";

extend("required", {
  ...required,
  message: "Field is required"
});
extend("numeric", {
  ...numeric,
  message: "Field accept only numbers"
});
extend("double", {
  ...double,
  message: "Invalid input provided"
});
export default {
  name: "AddLubeDialog",
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    state: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    details: {
      type: Object
    },
    progress: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    lube: {
      name: "",
      retailCost: "",
      pack: "",
      retailCostPerUnit: "",
      sellingPriceToCustomers: "",
      minimumThreshold: 0
    },
    reset: {
      name: " ",
      retailCost: "",
      pack: null,
      retailCostPerUnit: null,
      sellingPriceToCustomers: null,
      minimumThreshold: 0
    }
  }),
  watch: {
    loading(value) {
      if (!value) {
        this.lube = { ...this.reset };
      }
    },
    details(payload) {
      const { name, lubeId } = payload;
      this.lube = {
        id: payload.id,
        name,
        pack: lubeId && lubeId.length > 0 ? parseInt(lubeId[0].pack) : 0,
        retailCostPerUnit:
          lubeId && lubeId.length > 0
            ? parseInt(lubeId[0].retailCostPerUnit)
            : 0,
        sellingPriceToCustomers:
          lubeId && lubeId.length > 0
            ? parseFloat(lubeId[0].sellPriceToCustomers)
            : 0,
        minimumThreshold:
          lubeId && lubeId.length > 0 ? parseInt(lubeId[0].minimumThreshold) : 0
      };
    }
  },
  methods: {
    close() {
      this.$emit("actions", "edit");
    },
    editLube() {
      this.$emit("lube", this.lube);
    }
  },
  created() {}
};
</script>
